<template>
  <znl-dialog
    :visible="visible"
    :append-to-body="true"
    title="电子对账单"
    width="1100"
    @close="$emit('update:visible', false)"
    class="c-StatementDetails"
  >
    <h4>供应商基本信息：</h4>
    <el-row class="c-StatementDetails-row">
      <el-col :span="12">
        <label>公司名：</label>
        <span>{{statementInfo.SupplierName}}</span>
      </el-col>
      <el-col :span="12">
        <label>对账时间：</label>
        <span>{{statementInfo.StatementDateStart.substr(0, 10)}} ~ {{statementInfo.StatementDateEnd.substr(0, 10)}}</span>
      </el-col>
    </el-row>

    <el-row class="c-StatementDetails-row">
      <el-col :span="12">
        <label>联系人：</label>
        <span>{{statementInfo.ContactName}}</span>
      </el-col>
      <el-col :span="12">
        <label>账单核对：</label>
        <span>{{statementInfo.IsAudited ? '已核对' : '未核对'}}</span>
      </el-col>
    </el-row>

    <el-row class="c-StatementDetails-row">
      <el-col :span="12">
        <label>联系电话：</label>
        <span>{{statementInfo.ContactPhone}}</span>
      </el-col>
    </el-row>

    <h4>收款账号信息：</h4>
    <el-row class="c-StatementDetails-row">
      <el-col :span="12">
        <label>收款银行：</label>
        <span>{{statementInfo.PayBankName}}</span>
      </el-col>
      <el-col :span="12">
        <label>收款账号：</label>
        <span>{{statementInfo.PayBankAccount}}</span>
      </el-col>
    </el-row>

    <h4>业务信息：
      <znl-button type="text" v-if="includeTax" @click="showSetProductName=true">批量设置品名</znl-button>
    </h4>

    <div class="c-StatementDetails-grid-container">
      <grid
        :columns="columns"
        :datas="datas"
        ref="grid"
        type="edit"
        :defaultColPro="{minWidth: 80}"
      ></grid>
    </div>

    <div class="c-StatementDetails-tiprow">*此账单确认后，开票信息须与此账单保持一致</div>

    <div slot="footer" class="c-StatementDetails-footer">
      <!-- <znl-button
        :width="80"
        :height="30"
        @click="placeTheorder"
      >
        下单
      </znl-button>-->
      <znl-button :width="80" :height="30" @click="$emit('update:visible', false)">返回</znl-button>

      <znl-button
        :width="80"
        :height="30"
        style-type="main"
        v-if="!isaudited"
        @click="makeSureTheorder"
      >确认账单</znl-button>
    </div>

    <SetProductName :visible.sync="showSetProductName" @matchStr="matchStrHandler"></SetProductName>
  </znl-dialog>
</template>
<script>
import { StatementDetailsColumns } from './column';
import apis from '../../api';
import SetProductName from './SetProductName';
export default {
  name: 'StatementDetails',
  props: {
    visible: Boolean,
    ssguid: String,
    isaudited: Boolean,
    onBindData: Function,
    includeTax: Boolean
  },
  components: { SetProductName },
  data () {
    return {
      columns: [],
      datas: [],
      statementInfo: { StatementDateStart: '', StatementDateEnd: '' },
      showSetProductName: false
    };
  },
  watch: {
    ssguid (ssguid) {
      this.getStatementDatails(ssguid);
    },
    visible (val) {
      if (val) {
        this.$nextTick(() => {
          this.initColumns();
        });
      }
    }
  },
  methods: {
    initColumns () {
      const columns = StatementDetailsColumns.map(item => {
        return { ...item };
      });
      if (!this.includeTax) {
        columns.forEach((item, index) => {
          if (item.field === 'ProductName') {
            columns.splice(index, 1);
          }
        });
      }
      this.$refs.grid.changeColumns(columns);
    },
    placeTheorder () {
      console.log(222);
    },
    makeSureTheorder () {
      if (this.includeTax) {
        let obj = this.datas.find(v => v.ProductName === undefined || v.ProductName === '' || v.ProductName === null)
        if (obj != undefined) {
          this.$erroMess('请维护每一个型号的开票品名.');
          return
        }
      }
      this.$emit('update:visible', false);
      this.$confirm('请务必仔细核对电子对账单，是否确认该对账单已准确无误？', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          apis
            .auditStatement({
              SSGUID: this.ssguid,
              StatementType: 2,
              PName: this.datas.map(item => {
                return {
                  ProductName: item.ProductName,
                  Model: item.Model
                };
              })
            })
            .then(res => {
              if (res.Code === 0) {
                if (this.onBindData) {
                  this.onBindData();
                }
                this.getStatementDatails(this.ssguid);
                this.$succMess('确认成功');
              } else {
                this.$erroMess(res.Message);
              }
            });
        })
        .catch(() => {
          this.$emit('update:visible', true);
        });
    },
    getStatementDatails (SSGUID) {
      apis.getStatementDatails({ SSGUID, StatementType: 2 }).then(res => {
        if (res.Code === 0) {
          this.statementInfo = res.Data.Statement;
          this.datas = res.Data.StatementDetail || [];
        } else {
          this.$erroMess(res.Message);
        }
      });
    },
    matchStrHandler (datas) {
      console.log(datas, this.datas);
      datas.forEach(data => {
        this.datas.forEach(item => {
          if (item.Model === data.Model) {
            item.ProductName = data.ProductName;
            this.$refs.grid.updateRowData(item);
          }
        });
      });
    }
  }
};
</script>
<style lang="scss">
.c-StatementDetails {
  .ag-cell {
    text-align: center;
  }
  .znl-dialog__body {
    padding-top: 0;
    padding-bottom: 0;
  }
  h4 {
    line-height: 30px;
  }
  label {
    min-width: 80px;
    display: inline-block;
  }
  .c-StatementDetails-row {
    line-height: 30px;
    font-size: 12px;
  }
  .c-StatementDetails-grid-container {
    height: 300px;
  }
  .c-StatementDetails-tiprow {
    text-align: right;
    color: red;
    line-height: 30px;
  }
  .c-StatementDetails-footer {
    .znl-button {
      margin-left: 10px;
      //   &:first-child {
      //     margin-left: 0px;
      //     float: left;
      //     margin-top: 10px;
      //   }
    }
  }
}
</style>
